import { render } from "./HubView.vue?vue&type=template&id=55e79b08&scoped=true"
import script from "./HubView.vue?vue&type=script&lang=js"
export * from "./HubView.vue?vue&type=script&lang=js"

import "./HubView.vue?vue&type=style&index=0&id=55e79b08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55e79b08"]])

export default __exports__